import { useEffect, useState } from "react";
import { Box, Button, Typography } from '@mui/material';
import { get } from '../api/apiBridges/httpBridge';
import Loading from "components/Load";
import { useNavigate } from "react-router-dom";
import { DealDetails } from "./formatters";
import MoveGuideDialog from "components/MoveGuideDialog";


export const EIDealHeader = (data) => {
      const [$data, $setData] = useState({id: undefined, user_id:undefined, name:undefined, cdn:undefined, dealDetails: {}})
      const [loading, setLoading] = useState(false);
      const [open, setOpen] = useState(false);
      const navigate = useNavigate();
      //Вариант говно, другой не придумал
      useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          try {
            const responseData = await get('Deal/getHeader', {did:data});
            $setData(responseData);
          } catch (err) {console.log(err)}
          finally {
            setLoading(false);
          }
        };
        fetchData();
      }, []); 

      if (loading) return (   
        <Loading></Loading>
      )

      return (
        <Box sx={{ 
            height: '90%',
            width: '98%',
            borderLeft: '8px solid #bedcdd', 
            borderColor: "primary", 
            padding: '5px 5px 0px 5px', 
            margin: "1%",
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: '100%'}}>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: "100%", paddingTop: "10px"}}>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end', marginLeft: '7px'}}>
                <Typography sx={{fontSize: '16pt', lineHeight: '16pt', color: '#078376', mr: '5px'}}>#{$data.cdn}</Typography>
                <Typography sx={{fontSize: '16pt', lineHeight: '16pt', color: 'gray'}}> - {$data.user_id}-{$data.name}</Typography>
              </div>
              <DealDetails value={{...$data.dealDetails, actions: {combined: () => {setOpen(true)}}}}/>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', height: "100%", justifyContent: 'center'}}>
              <Button 
                variant="contained" 
                sx={{ textTransform: 'none', backgroundColor: '#078376', borderRadius:'10px'}} 
                onClick={() => { navigate(`/deal/${data}`); }}
              >
                Открыть сделку
              </Button>
            </div>
          </div>
          <MoveGuideDialog deal_id={$data.id} open={open} onClose={() => {setOpen(false)}}/>
        </Box>
      )
    }


export const EIDealClientHeader = (data) => {
      const [$data, $setData] = useState({id: undefined, user_id:undefined, name:undefined, cdn:undefined, dealDetails: {}})
      const [loading, setLoading] = useState(false);
      const navigate = useNavigate();
      //Вариант говно, другой не придумал
      useEffect(() => {
        const fetchData = async () => {
          setLoading(true);
          try {
            const responseData = await get('Deal/getHeader', {did:data});
            $setData(responseData);
          } catch (err) {console.log(err)}
          finally {
            setLoading(false);
          }
        };
        fetchData();
      }, []); 

      if (loading) return (   
        <Loading></Loading>
      )

      return (
        <Box sx={{ 
            height: '90%',
            width: '98%',
            borderLeft: '8px solid #bedcdd', 
            borderColor: "primary", 
            padding: '5px 5px 0px 5px', 
            margin: "1%",
        }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: '100%'}}>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: "100%", paddingTop: "10px"}}>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-end', marginLeft: '10px'}}>
                <Typography sx={{fontSize: '16pt', lineHeight: '16pt', color: '#078376', mr: '5px'}}>#{$data.cdn}</Typography>
                <Typography sx={{fontSize: '16pt', lineHeight: '16pt', color: 'gray'}}> - {$data.user_id}-{$data.name}</Typography>
              </div>
              <DealDetails value={$data?.dealDetails || {}}/>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', height: "100%", justifyContent: 'center'}}>
              <Button 
                variant="contained" 
                sx={{ textTransform: 'none', backgroundColor: '#078376', borderRadius:'10px'}} 
                onClick={() => { navigate(`/clientDeal/${data}`); }}
              >
                Открыть сделку
              </Button>
            </div>
          </div>
        </Box>
      )
    }
